export default {
  name: "PortalOther"
};